export default __webpack_public_path__ + "static/B0292-5713f9fd1124c97b5f57e86241b9ad43.png";